// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-field-table.v-text-field--outline input{text-align:right!important}.centered-input input{text-align:right;font-weight:700}", ""]);
// Exports
module.exports = exports;
